import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import './assets/icon/iconfont.css'

import Debounce from "./uitls/debounce";
import Pagination from "./components/global/pagination.vue";
import DailogComp from './components/global/dailog/index'
import axios from './uitls/request'
//导入视频播放器
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import 'videojs-contrib-hls'
import { roleFilter, exportFile } from './uitls/globalFun'
import echarts from 'echarts'
import elTableInfiniteScroll from 'el-table-infinite-scroll'

Vue.config.productionTip = false;

Vue.component("Debounce", Debounce); //防抖节流组件,包裹input或button
Vue.component("Pagination", Pagination); //分页
Vue.use(elTableInfiniteScroll)
Vue.use(ElementUI);
Vue.use(VueVideoPlayer);
Vue.prototype.$dailog = DailogComp;
Vue.prototype.$axios = axios;
Vue.prototype.$exportFile = exportFile;
Vue.prototype.$roleFilter = roleFilter;
Vue.prototype.$echarts = echarts;
Vue.prototype.$tagTime = (time, tag) => {
    if (!tag) {
        return ""
    }
    if (!time) {
        return ""
    }
    let tmpTime = new Date(time)
    if (isNaN(tmpTime)) {
        return ""
    }
    let year = tmpTime.getFullYear(),
        month = tmpTime.getMonth() + 1,
        date = tmpTime.getDate(),
        hour = tmpTime.getHours(),
        minute = tmpTime.getMinutes(),
        second = tmpTime.getSeconds()
    //  不足10前面补0
    if (month < 10) {
        month = "0" + month
    }
    //  不足10前面补0
    if (date < 10) {
        date = "0" + date
    }
    //  不足10前面补0
    if (hour < 10) {
        hour = "0" + hour
    }
    //  不足10前面补0
    if (minute < 10) {
        minute = "0" + minute
    }
    //  不足10前面补0
    if (second < 10) {
        second = "0" + second
    }
    return tag.replace("yyyy", year).replace("MM", month).replace("dd", date).replace("HH", hour).replace("mm", minute).replace("ss", second)
}
Vue.prototype.$uploadForMat = (format) => {
    let str = format.split('.')[format.split('.').length - 1]
    if (str == 'mp3' || str == 'MP3' || str == 'wav' || str == 'WAV' || str == 'jpg' || str == 'JPG' || str == 'jpeg' || str == 'JPEG' || str == 'png' || str == 'PNG') {
        return true
    } else {
        return false
    }
}
Vue.prototype.$expForMat = (format) => {
    let str = format.split('.')[format.split('.').length - 1]
    if (str == 'mp3' || str == 'MP3' || str == 'wav' || str == 'WAV') {
        return true
    } else {
        return false
    }
}
Vue.filter("getTimeByTimestamp", (time) => {
    let date = new Date(time);
    return (
        date.toLocaleDateString().replace(/\//g, "-") +
        " " +
        date.toTimeString().substr(0, 8)
    );
});

Vue.filter("getLvTextByLv", (lv) => {
    let lvList = [
        '',
        "一级",
        "二级",
        "三级",
        "四级",
        "五级",
        "六级",
        "七级",
        "八级",
        "九级",
        "十级",
        "初级",
        "中级",
        "高级"
    ];
    return lvList[lv * 1]
});
Vue.filter("txName", (tx) => {
    let txList = [
        '',
        "单选题",
        "多选题",
        "填空多选题",
        "音频题",
    ];
    return txList[tx * 1]
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");